<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';

	interface Props {
		content: ISbStoryData<{
			content: ISbStoryData[];
			mobile_start: number;
			mobile_end: number;
			desktop_start: number;
			desktop_end: number;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<PageGrid16 class="max-lg:px-5">
	<div
		use:editable={content}
		style={`--col-start: ${content.mobile_start || 1}; --col-end: ${content.mobile_end || 5}; --lg-col-start-desktop: ${content.desktop_start || 1}; --lg-col-end-desktop: ${content.desktop_end || 17}`}
	>
		{#each content.content || [] as block}
			<Blok content={block} />
		{/each}
	</div>
</PageGrid16>

<style>
	div {
		grid-column-start: var(--col-start);
		grid-column-end: var(--col-end);

		@media (min-width: 1024px) {
			grid-column-start: var(--lg-col-start-desktop);
			grid-column-end: var(--lg-col-end-desktop);
		}
	}
</style>
